module.exports = __webpack_public_path__ + "static/media/oekotex.b1076cb4.png";